import { useAudioEffect } from './useAudioEffect';
import audioEffect from '~/assets/mp3/toggle_switch_on.mp3';

export function useToggleAudioEffect() {
  return useAudioEffect(audioEffect);
}
